import loadable, { LoadableComponent } from '@loadable/component';
import { QueryLoadingAbsolute } from 'modules/common/components/QueryLoading/QueryLoading';
import { RouteConfiguration } from 'modules/common/types/RouteConfiguration';
import { Route } from 'react-router-dom';

const PATH_INSCRIBE = '/inscribe';

export const InscribeRoutesConfig: { [key: string]: RouteConfiguration } = {
  Index: {
    path: PATH_INSCRIBE,
    generatePath: () => PATH_INSCRIBE,
  },
};

const LoadableInscribeContainer: LoadableComponent<any> = loadable(
  async () =>
    import('./screens').then(module => module.Inscribe),
  {
    fallback: <QueryLoadingAbsolute />,
  },
);

export function InscribeRoutes() {
  return (
    <Route
      path={InscribeRoutesConfig.Index.path}
      exact={true}
      component={LoadableInscribeContainer}
    />
  );
}
